import { InjectionToken } from '@angular/core';
import { IonicComponentRef } from '@lyceo/shared/util-models';

export const ALERT_MODAL: InjectionToken<IonicComponentRef> =
  new InjectionToken<IonicComponentRef>('ALERT_MODAL');
